/** Locale date+time formatting for generated/observed timestamps (design.md §5.1). Pure — no I/O. */

const DATE_TIME_FORMATTER = new Intl.DateTimeFormat("es-CO", {
  dateStyle: "medium",
  timeStyle: "short",
});

/** Formats an ISO-8601 instant (e.g. `AdminOverview.generatedAt`) into a locale-readable date+time string. */
export function formatDateTime(iso: string): string {
  return DATE_TIME_FORMATTER.format(new Date(iso));
}

/**
 * Converts an ISO-8601 instant into the local `YYYY-MM-DDTHH:mm` shape an
 * `<input type="datetime-local">` needs as its `value`, so a scheduled date
 * round-trips through the browser's native date/time picker instead of a
 * bare text field. Empty or unparsable input yields "" (an empty field,
 * never a thrown error or "Invalid Date" text).
 */
export function isoToDatetimeLocalValue(iso: string): string {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (value: number) => String(value).padStart(2, "0");
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

/**
 * Converts an `<input type="datetime-local">` value (local time, no
 * timezone) back into a UTC ISO-8601 instant for the API. Empty input yields
 * "" (matches the "sin programar" draft state).
 */
export function datetimeLocalValueToIso(value: string): string {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString();
}
